
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 100 131","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M66.667 16.375c0 9.045-7.474 16.375-16.667 16.375-9.193 0-16.667-7.33-16.667-16.375S40.807 0 50 0c9.193 0 16.667 7.33 16.667 16.375zm-26.12 27.172c3.02.742 6.224 1.484 9.505 1.484 10.39 0 20.078-5.168 25.73-13.714l4.739-7.128c2.5-3.79 7.656-4.861 11.536-2.395 3.855 2.467 4.948 7.527 2.422 11.34l-4.713 7.113C85 47.437 78.437 53.04 70.833 56.698v66.114c0 4.529-3.724 8.188-8.333 8.188-4.61 0-8.333-3.659-8.333-8.188V98.25h-8.334v24.562c0 4.529-3.724 8.188-8.333 8.188-4.61 0-8.333-3.659-8.333-8.188V56.647c-7.388-3.582-13.818-9.032-18.524-16.196l-5.078-7.24c-2.552-3.787-1.518-8.858 2.313-11.368 3.828-2.508 9.002-1.492 11.554 2.272l5.078 7.484a30.72 30.72 0 0015.308 11.718c.26.051.495.128.729.23z","fill":"currentColor"}})])
          )
        }
      }
    